//
import Model from '@/models/Model'
import ACancelModel from '@/models/Actions/ACancel'
import SlDetailSaleCreditNoteModel from '@/models/Sale/SlDetailSaleCreditNote'

/**
 * This class describes a sl sale credit note.
 * @class   SlSaleCreditNote (name)
 */
export default class SlSaleCreditNote extends Model {

    //
    static includes = [
        'sl_detail_sale_credit_notes',
        'sl_service_order.sl_sale_ticket_affected',
        'sl_service_order.sl_sale_invoice_affected',
    ]

    /**
     * 
     */
    cancel() {
        return this.hasMany(ACancelModel)
    }

    mapSelected = item => {
        return new SlDetailSaleCreditNoteModel(item)
    }

    /**
     * { property_description }
     * @type       {<type>}
     */
    get sl_customer_branch_offices_address() {
        return this.getProperty('sl_customer_branch_offices.address', '-')
    }

    /**
     * { property_description }
     * @type       {<type>}
     */
    get sl_customer_business_name() {
        return this.getProperty('sl_customer.business_name', '-')
    }

    /**
     * { property_description }
     * @type       {<type>}
     */
    get sl_customer_rut() {
        return this.getProperty('sl_customer.rut', '')
    }

    reset() {
        //
        this.sl_detail_sale_credit_notes = this.sl_detail_sale_credit_notes
            ? this.sl_detail_sale_credit_notes.map(this.mapSelected)
            : []
        //
        return this
    }

    /**
     * { function_description }
     * @return     {string}  { description_of_the_return_value }
     */
    resource() {
        return 'sl_sale_credit_note'
    }

    /**
     * { property_description }
     * @type       {string}
     */
    get typeDocument() {
        if (this.sl_service_order) {
            if (this.sl_service_order.sl_sale_invoice_affected)
                return 'FACTURA ELECTRÓNICA'
            else if (this.sl_service_order.sl_sale_ticket_affected) {
                return 'BOLETA ELECTRÓNICA'
            }
        } else {
            return '-'
        }
    }

    /**
     * { property_description }
     * @type       {string}
     */
    get numberRerefence() {
        if (this.sl_service_order) {
            if (this.sl_service_order.sl_sale_invoice_affected)
                return this.sl_service_order.sl_sale_invoice_affected.number
            else if (this.sl_service_order.sl_sale_ticket_affected) {
                return this.sl_service_order.sl_sale_ticket_affected.number
            }
        } else {
            return '-'
        }
    }

    downloadPdf() {
        return new Promise((resolve, reject) =>
            this.$http
                .get(
                    process.env.VUE_APP_API_ROUTE +
                        '/sl_sale_credit_note/' +
                        this.id +
                        '/pdf',
                    { responseType: 'blob' }
                )
                .then(response => {
                    const linkSource = URL.createObjectURL(response.data)
                    const downloadLink = document.createElement('a')
                    const fileName = `${this.number}-NOTA_DE_CREDITO_ELECTRONICA.pdf`
                    downloadLink.href = linkSource
                    downloadLink.download = fileName
                    downloadLink.click()
                    resolve()
                })
                .catch(reject)
        )
    }

    /**
     * 
     */
    toCancel() {
        return this.clean([
            'id',
            'reason',
        ])
    }

    /**
     * 
     */
    toPdf() {
        return this.downloadPdf()
    }
}
